import { RouterModule, Routes } from '@angular/router';
import { samlSsoRoute } from '@ats/auth-components';
import { AuthErrorComponent } from './components/auth-error/auth-error.component';
import { AuthGuard } from './core/guards/auth.guard';
import { DataIntegrityGuard } from './core/guards/data-integrity.guard';
import { TranslationsReadyGuard } from './core/guards/translations-ready.guard';

const routes: Routes = [
  samlSsoRoute,
  {
    path: 'parts',
    loadChildren: () => import('./containers/parts/parts.module').then((m) => m.PartsModule),
    canActivate: [AuthGuard, TranslationsReadyGuard]
  },
  {
    path: 'manufacturers',
    loadChildren: () =>
      import('./containers/manufacturers/manufacturers.module').then((m) => m.ManufacturersModule),
    canActivate: [AuthGuard, TranslationsReadyGuard]
  },
  {
    path: 'requests',
    loadChildren: () =>
      import('./containers/requests/requests.module').then((m) => m.RequestsModule),
    canActivate: [AuthGuard, TranslationsReadyGuard]
  },
  {
    path: 'nouns',
    loadChildren: () => import('./containers/nouns/nouns.module').then((m) => m.NounsModule),
    canActivate: [AuthGuard, TranslationsReadyGuard]
  },
  {
    path: 'imports',
    loadChildren: () => import('./containers/imports/imports.module').then((m) => m.ImportsModule),
    canActivate: [AuthGuard, DataIntegrityGuard, TranslationsReadyGuard]
  },
  {
    path: 'auth_error',
    component: AuthErrorComponent
  },
  { path: '**', redirectTo: 'parts', pathMatch: 'full' }
];

export const appRouting = RouterModule.forRoot(routes);
